import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55785184"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "patient-detail" }
const _hoisted_2 = {
  key: 0,
  class: "patient-detail__content"
}
const _hoisted_3 = {
  key: 0,
  id: "qrCodeBlock",
  class: "patient-detail__qr-code"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "patient-detail__qr-code-text" }, " Отсканировав QR код, пациент получит Отчет о гигиене полости рта в Max, а также напоминание о следующем приеме на профессиональную гигиену ", -1))
const _hoisted_6 = {
  key: 1,
  class: "patient-detail__search"
}

import { computed, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { PatientType, ReportViewType } from '@/shared/types'
import { patientApi } from '@/shared/api'
import { showErrorMessage } from '@/shared/utils'
import { useOrganizationModules, usePatient } from '@/shared/composables'
import { REPORT_VIEW } from '@/shared/constants'
import { EPatientDetailCard } from '@/entities/EPatientDetailCard'
import { FRemovePatient } from '@/features/FRemovePatient'
import PlaqueReports from '@/widgets/WPatientDetail/components/PlaqueReports.vue'
import PeriodontalReports from '@/widgets/WPatientDetail/components/PeriodontalReports.vue'
import RiskMapReports from '@/widgets/WPatientDetail/components/RiskMapReports.vue'
import ChoiceReportCategory from '@/widgets/WPatientDetail/components/ChoiceReportCategory.vue'
import BrushMapReports from '@/widgets/WPatientDetail/components/BrushMapReports.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()

const { isPatientUpdated, setUpdatePatient } = usePatient()

const loading = ref(false)
const searchingData = ref<string>()

const patientId = computed((): string | string[] => route.params.patientId)
const maxEnabled = computed(() => process.env.VUE_APP_MAX_ENABLE === 'true')

const patientInfo = ref<PatientType>({
  cart_number: '',
  date: '',
  id: 0,
  name: '',
  email: '',
  patronymic: '',
  phone: '',
  surname: '',
})

const reportsType = ref<ReportViewType>()

const qrCode = computed(() => {
  let domain = window.origin

  if (process.env.NODE_ENV === 'production') {
    domain = process.env.VUE_APP_BASE_URI
  }

  if (!maxEnabled.value) {
    return ''
  }

  return `${domain}/api/web/admin/patients/${patientId.value}/get-qr`
})

const isPreviewMode = computed(() => route.query['view-mode'] === '1')
const isPeriodontalPage = computed(() =>
  route.path.includes('periodontal-report')
)

const reportViewByCurrentPage = {
  PlaqueIndexReportPage: REPORT_VIEW.plaqueIndex,
  PatientPage: REPORT_VIEW.plaqueIndex,
  OldReportPage: REPORT_VIEW.plaqueIndex,
  PeriodontalPage: REPORT_VIEW.periodontal,
  BrushMapPage: REPORT_VIEW.brushMap,
  ScreeningReportPage: REPORT_VIEW.screening,
  RiskMapPage: REPORT_VIEW.riskMap,
}

watch(patientId, (newPatientId, oldPatientId) => {
  if (
    newPatientId &&
    newPatientId !== oldPatientId &&
    patientId.value !== 'null-patient'
  ) {
    getPatientInfo()
  }
  if (patientId.value === 'null-patient') {
    reportsType.value = REPORT_VIEW.plaqueIndex
  }
})

watch(
  () => isPatientUpdated.value,
  (isUpdated) => {
    if (isUpdated) {
      getPatientInfo()
      setUpdatePatient(false)
    }
  }
)

const getPatientInfo = async (): Promise<void> => {
  loading.value = true

  const [error, response] = await patientApi.getPatientInfo(
    Number(patientId.value)
  )

  if (error) {
    showErrorMessage(error)
  } else {
    patientInfo.value = response.data.patient
  }

  loading.value = false
}

const handleGetReports = (reportType: ReportViewType): void => {
  reportsType.value = reportType
}

const handleOpenPatientEditionPage = (): void => {
  router.push({
    name: 'PatientEditionPage',
    params: { patientId: patientId.value },
  })
}
const { organizationModules } = useOrganizationModules()

onMounted(() => {
  reportsType.value = reportViewByCurrentPage[route.name]
  if (!reportsType.value) {
    if (organizationModules.value.indexOf('plaque') > -1) {
      reportsType.value = REPORT_VIEW.plaqueIndex
    } else if (organizationModules.value.indexOf('periodontology') > -1) {
      reportsType.value = REPORT_VIEW.periodontal
    } else if (organizationModules.value.indexOf('brushmap') > -1) {
      reportsType.value = REPORT_VIEW.brushMap
    } else {
      reportsType.value = undefined
    }
  }

  if (patientId.value !== 'null-patient') {
    getPatientInfo()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_icon_template = _resolveComponent("icon-template")!
  const _component_el_input = _resolveComponent("el-input")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(patientId) !== 'null-patient')
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(EPatientDetailCard), { patientInfo: patientInfo.value }, {
            open: _withCtx(() => [
              _createElementVNode("button", { onClick: handleOpenPatientEditionPage }, [
                _createVNode(_component_icon_template, {
                  class: "patient-icon",
                  height: "12",
                  name: "tools",
                  width: "12"
                })
              ])
            ]),
            remove: _withCtx(() => [
              _createVNode(_unref(FRemovePatient), { patientId: _unref(patientId) }, null, 8, ["patientId"])
            ]),
            _: 1
          }, 8, ["patientInfo"]),
          (_unref(isPreviewMode) && !_unref(isPeriodontalPage))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: _unref(qrCode),
                  class: "patient-detail__qr-code-item",
                  onerror: "qrCodeBlock.style.display = 'none'"
                }, null, 8, _hoisted_4),
                _hoisted_5
              ]))
            : _createCommentVNode("", true),
          _createVNode(ChoiceReportCategory, {
            reportsType: reportsType.value,
            onChangeCategory: handleGetReports
          }, null, 8, ["reportsType"])
        ])), [
          [_directive_loading, loading.value]
        ])
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_el_input, {
            modelValue: searchingData.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchingData).value = $event)),
            clearable: "",
            placeholder: "Номер отчёта...",
            size: "small"
          }, null, 8, ["modelValue"])
        ])),
    (reportsType.value === _unref(REPORT_VIEW).plaqueIndex)
      ? (_openBlock(), _createBlock(PlaqueReports, {
          key: 2,
          search: searchingData.value
        }, null, 8, ["search"]))
      : _createCommentVNode("", true),
    (
        reportsType.value === _unref(REPORT_VIEW).periodontal ||
        reportsType.value === _unref(REPORT_VIEW).screening
      )
      ? (_openBlock(), _createBlock(PeriodontalReports, { key: 3 }))
      : _createCommentVNode("", true),
    (reportsType.value === _unref(REPORT_VIEW).brushMap)
      ? (_openBlock(), _createBlock(BrushMapReports, { key: 4 }))
      : _createCommentVNode("", true),
    (reportsType.value === _unref(REPORT_VIEW).riskMap)
      ? (_openBlock(), _createBlock(RiskMapReports, {
          key: 5,
          search: searchingData.value
        }, null, 8, ["search"]))
      : _createCommentVNode("", true)
  ]))
}
}

})